export interface UpdatePinnedAppsOrderResponse {
  success: boolean
  data: {
    message: string
  }
}
